import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {DashboardSearchParams} from '../../types'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {useGetDashboardOps} from '../../query/useGetDashboardOps'
import {DashboardSimpleCardSkeleton} from '../dashboard-simple-card-skeleton/DashboardSimpleCardSkeleton'
import {formatNumber} from '@/utilities/helpers'

export const DashboardPlannedAccessesCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(DashboardSearchParams)
    const {data, isLoading} = useGetDashboardOps({fields: ['graph'], ...searchParams})

    if (isLoading) {
        return <DashboardSimpleCardSkeleton title={t('dashboard:planned_accesses')} />
    }

    return (
        <DashboardCard title={t('dashboard:planned_accesses')}>
            <Grid columns={2} gap={2}>
                <Text palette="neutral" shade="900" size="displaySm" weight={700}>
                    {formatNumber(data?.accessCounters?.planned ?? 0)}
                </Text>
            </Grid>
        </DashboardCard>
    )
}
